import React, { useRef, useState } from "react";
import classes from "./LocationMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { useHistory } from "react-router-dom";
import {
  AddIconGray,
  EditIconGray,
  ImageWithLocationIcon,
  TrashIconGray,
  cancelIcon,
  AddIconBlue,
  EditIconDarkGray,
} from "../../../../../constant/imagePath";
import { Input } from "../../../../../stories/Input/Input";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { Button } from "../../../../../stories/Button/Button";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import Maps from "../../../../../components/Maps";
import { setPersonalData } from "../../../../../store/Actions/authAction";
import AddedLocationCard from '../../../../../stories/AddedLocationCard/AddedLocationCard'

const LocationMobile = () => {
  const history = useHistory();
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer.address
  );

  const dispatch = useDispatch();
  const [venueName, setVenueName] = useState("");
  const [address, setAddress] = useState("");
  const [locations, setLocations] = useState(
    getDataFromRedux ? getDataFromRedux : []
  );
  const [locationDetail, setLocationDetail] = useState({});
  const [coordinate, setCoordinate] = useState({});

  const [updateConfig, setUpdateConfig] = useState({
    state: false,
    item: null,
    index: null,
  });


  // Edit Location
  const editLocation = (item, index) => {
    setVenueName(item.venueName);
    setAddress(item.address);
    const newLocs = locations.slice()
    newLocs.splice(index, 1, {
      venueName,
      address,
      img: ImageWithLocationIcon,
      ...locationDetail
    })

    setUpdateConfig({
      state: true,
      item,
      index,
    });
  };

  // Delete Location
  const deleteLocation = (id) => {
    const newArr = locations.filter((item) => item._id !== id);
    setLocations(newArr);

    setUpdateConfig({
      state: false,
      item: null,
      index: null,
    });
  };

  // add location
  const addlocation = () => {
    if (updateConfig.state === true) {
      const _locations = [...locations];
      _locations[updateConfig.index] = {
        venueName,
        address,
        img: ImageWithLocationIcon,
        ...locationDetail,
      };
      setLocations(_locations);
    } else {
      const newDoc = {
        _id: Math.random() * Math.random(),
        venueName,
        address,
        img: ImageWithLocationIcon,
        ...locationDetail,
      };
      setLocations((p) => [...p, newDoc]);
    }

    setVenueName("");
    setAddress("");
    setUpdateConfig({
      state: false,
      item: null,
      index: null,
    });
  };

  function saveDataIntoRedux() {
    dispatch(setPersonalData("address", locations));
  }

  return (
    <div className={[classes.LocationScreen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Edit Lesson Info
        </p>
      </div>

      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col sm={12}>
            <Col sm={12} className={[classes.mb32].join(" ")}>
              <Tabs
                tabsData={[
                  { label: "Basic info", activeText: "basic-info" },
                  { label: "What’s included", activeText: "whats-included" },
                  { label: "Location", activeText: "location" },
                ]}
                state={{ label: activeTab }}
                setState={(item) => dispatch(setActiveTab(item?.activeText))}
                matchWithActiveText={true}
              />
            </Col>

            <Col md={12}>
              {locations?.map((item, i) => {
                return (
                  <div
                    className={[classes.addedLocation, classes.mb32].join(" ")}
                    key={i}
                  >
                    <div className={[classes.dflex].join(" ")}>
                      <div className={[classes.imgBox].join(" ")}>
                        <img src={item?.img} alt="..." />
                      </div>
                      <div className={[classes.pl16].join(" ")}>
                        <p
                          style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfDimGray,
                            fontSzie: "12px",
                            lineHeight: "16px",
                          }}
                          className={[classes.mb4].join(" ")}
                        >
                          {item?.address}
                        </p>

                        <h6
                          style={{
                            ...Fonts.b3,
                            color: Colors.neutralShadesOfNero,
                            fontSzie: "16px",
                            lineHeight: "24px",
                          }}
                          className={[classes.mb8].join(" ")}
                        >
                          {item?.venueName}
                        </h6>

                        <p
                          style={{
                            ...Fonts.b1Mobile,
                            color: Colors.neutralShadesOfDimGray,
                            fontSzie: "16px",
                            lineHeight: "24px",
                          }}
                        >
                          {`${item?.state + " , "}`}
                          {`${item?.city + " , "}`}
                          {item?.country}
                        </p>
                      </div>
                    </div>

                    <div className={[classes.dflex, classes.mt12].join(" ")}>
                      <Button
                        icon={TrashIconGray}
                        onClick={() => deleteLocation(item?._id)}
                        primary={false}
                        size={"Small"}
                        customStyle={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                          marginRight: "8px",
                        }}
                      />
                      <Button
                        icon={EditIconDarkGray}
                        onClick={() => editLocation(item, i)}
                        size={"Small"}
                        primary={false}
                        customStyle={{
                          border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </Col>

            <Col sm={12} className={[classes.mb32].join(" ")}>
              <Input
                label={"Venue Name (Optional)"}
                state={venueName}
                setter={setVenueName}
                placeholder=""
              />
            </Col>

            <Col sm={12} className={[classes.mb32].join(" ")}>
              <Maps
                type={"places"}
                label={"Address"}
                setAddress={setAddress}
                placeholder={"Type here.."}
                setCoordinates={setCoordinate}
                setPlaceDetail={setLocationDetail}
                className={classes.placesInput}
              />
            </Col>
            <Col sm={12} className={`${[classes.mb40].join(" ")}`}>
              <LinkButtonWithIcon
                leftIcon={AddIconBlue}
                text={"Add another place"}
                customStyle={{
                  ...Fonts.b2,
                  fontSize: "14px",
                  lineHeight: "20px",
                }}
                primary={true}
                onClick={addlocation}
                disabled={address == "" ? true : false}
              />
            </Col>
          </Col>

          <Col xs={12} style={{ alignSelf: "flex-end" }}>
            <Button
              customStyle={{ width: "100%", height: "56px" }}
              primary={true}
              size="Large"
              onClick={saveDataIntoRedux}
            >
              Save changes
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default LocationMobile;
